import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppEffects } from './app-effects';
import { initialAppState } from './app-state';
import { SessionStateModule } from '../session/session-state.module';
import { RouterStateModule } from '../router/router-state.module';
import { AuthStateModule } from '../auth/auth-state.module';
import { ToastStateModule } from '../toast/toast-state.module';
import { DeliveriesStateModule } from '../deliveries/deliveries-state.module';
import { PreferenceStateModule } from '../preference/preference-state.module';
import { EntityStateModule } from '../shared/entities/entities-state.module';
import { LocationStateModule } from '../locations/locations-state.module';
import { metaReducers } from './app-meta-reducer';
import { GlobalStateModule } from '../global/global-state.module';
import { BillingStateModule } from '../billing/billing-state.module';
import { IntercomStateModule } from '../intercom/intercom-state.module';
import { CloudinaryEffects } from '../shared/effects/cloudinary-effects';
import { combineReducers } from '@core/utils/state';
import { ProfileStateModule } from '../profile/profile-state.module';
import { UsersStateModule } from '../users/users-state.module';
import { DriversStateModule } from '../drivers/drivers-state.module';

@NgModule({
  imports: [
    EffectsModule.forRoot([
      AppEffects,
      CloudinaryEffects
    ]),
    StoreModule.forRoot({}, {
      initialState: initialAppState,
      metaReducers: metaReducers,
      reducerFactory: combineReducers,
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
        strictStateSerializability: false,
        strictActionSerializability: false
      }
    }),
    BillingStateModule,
    RouterStateModule,
    SessionStateModule,
    AuthStateModule,
    ToastStateModule,
    DeliveriesStateModule,
    DriversStateModule,
    PreferenceStateModule,
    EntityStateModule,
    LocationStateModule,
    GlobalStateModule,
    IntercomStateModule,
    ProfileStateModule,
    UsersStateModule
  ],
  declarations: []
})
export class AppStateModule {
}
